import { useEffect, useState } from 'react'
import { previewTemplateContent } from './phishingService'

export function useQrPreview(body, enabled, isArabic) {
  const [result, setResult] = useState({ html: '', error: false })
  useEffect(() => {
    if (!enabled) return undefined
    const controller = new AbortController()
    setResult({ html: '', error: false })
    previewTemplateContent(body || '', isArabic, controller.signal)
      .then(data => !controller.signal.aborted && setResult({ html: data.Html, error: false }))
      .catch(() => !controller.signal.aborted && setResult({ html: '', error: true }))
    return () => controller.abort()
  }, [body, enabled, isArabic])
  return result
}
